export const parentEventMegaFormValues = {
  parentEventMain: {
    parentEventId: "",
    parentEventDetails: {
      eventName: "ארוע מיוחד לבדיקה",
      eventType: {
        customValue: 3,
        icon: null,
        key: 3,
        text: "תרומה",
      },
      eventStartDate: "2023-07-24",
      eventStartHour: "23:00",
      eventEndDate: "2023-07-25",
      eventEndHour: "01:00",
      registrationStartDate: "2023-07-25",
      registrationEndDate: "2023-07-25",
      eventDescription: "new description",
      closedToMembers: true,
      brothersDiscount: true,
      brothersDiscountPeriod: {
        customValue: 401,
        icon: null,
        key: 401,
        text: "חשבון וזיכרון",
      },
    },
    parentEventAdvancedDetails: {
      eventIndex: "11",
      gainCenter1: "4444",
      gainCenter3: "4141",
    },
  },
  AllChildEvents: {
    ActiveChildEvents: [
      {
        id: 36733,
        eventPrice: 10,
        eventFormMaagal: [""],
        eventFormLayers: [
          false,
          false,
          false,
          true,
          false,
          true,
          false,
          false,
          false,
          false,
          false,
          false,
          false,
          false,
          false,
        ],
        eventFormPriceChanges: [],
        organs: [
          {
            code: "1358",
            id: 1358,
            isChosen: true,
            name: "צרעה",
            nestOrCounty: "nest",
            parent: 2108,
            has_add_permission: true,
          },
          {
            code: "1359",
            id: 1359,
            isChosen: true,
            name: "שואבה",
            nestOrCounty: "nest",
            parent: 2108,
            has_add_permission: true,
          },
          {
            code: "1360",
            id: 1360,
            isChosen: true,
            name: "מעלה החמישה",
            nestOrCounty: "nest",
            parent: 2108,
            has_add_permission: true,
          },
          {
            code: "1361",
            id: 1361,
            isChosen: true,
            name: "קרית ענבים",
            nestOrCounty: "nest",
            parent: 2108,
            has_add_permission: true,
          },
          {
            code: "1362",
            id: 1362,
            isChosen: true,
            name: "רמת רחל",
            nestOrCounty: "nest",
            parent: 2108,
            has_add_permission: true,
          },
          {
            code: "200952",
            id: 200952,
            isChosen: true,
            name: 'נתיב הל"ה',
            nestOrCounty: "nest",
            parent: 2108,
            has_add_permission: true,
          },
          {
            code: "1354",
            id: 1354,
            isChosen: true,
            name: 'מ"א מגילות',
            nestOrCounty: "nest",
            parent: 2109,
            has_add_permission: true,
          },
          {
            code: "1400",
            id: 1400,
            isChosen: true,
            name: "מצפה שלם",
            nestOrCounty: "nest",
            parent: 2109,
            has_add_permission: true,
          },
          {
            code: "1401",
            id: 1401,
            isChosen: true,
            name: "קליה",
            nestOrCounty: "nest",
            parent: 2109,
            has_add_permission: true,
          },
          {
            code: "1402",
            id: 1402,
            isChosen: true,
            name: "אלמוג",
            nestOrCounty: "nest",
            parent: 2109,
            has_add_permission: true,
          },
          {
            code: "1403",
            id: 1403,
            isChosen: true,
            name: "ורד יריחו",
            nestOrCounty: "nest",
            parent: 2109,
            has_add_permission: true,
          },
          {
            code: "1404",
            id: 1404,
            isChosen: true,
            name: "בית הערבה",
            nestOrCounty: "nest",
            parent: 2109,
            has_add_permission: true,
          },
          {
            code: "201015",
            id: 201015,
            isChosen: true,
            name: "קדם ערבה",
            nestOrCounty: "nest",
            parent: 2109,
            has_add_permission: true,
          },
        ],
        layers: [
          {
            layerName: "א'",
            layerId: 1,
            chosen: false,
          },
          {
            layerName: "ב'",
            layerId: 2,
            chosen: false,
          },
          {
            layerName: "ג'",
            layerId: 3,
            chosen: false,
          },
          {
            layerName: "ד'",
            layerId: 4,
            chosen: true,
          },
          {
            layerName: "ה'",
            layerId: 5,
            chosen: false,
          },
          {
            layerName: "ו'",
            layerId: 6,
            chosen: true,
          },
          {
            layerName: "ז'",
            layerId: 7,
            chosen: false,
          },
          {
            layerName: "ח'",
            layerId: 8,
            chosen: false,
          },
          {
            layerName: "ט'",
            layerId: 9,
            chosen: false,
          },
          {
            layerName: "י'",
            layerId: 10,
            chosen: false,
          },
          {
            layerName: 'י"א',
            layerId: 11,
            chosen: false,
          },
          {
            layerName: 'י"ב',
            layerId: 12,
            chosen: false,
          },
          {
            layerName: 'י"ג',
            layerId: 13,
            chosen: false,
          },
          {
            layerName: 'י"ד',
            layerId: 14,
            chosen: false,
          },
          {
            layerName: "מבוגרים",
            layerId: 15,
            chosen: false,
          },
        ],
        circles: [
          {
            circleId: 1600,
            code: "1600",
            name: "הקהילה היהודית",
            has_add_permission: true,
            value: false,
          },
        ],
        priceChanges: [],
        childEventAdvancedDetails: {
          eventDescription: "new description",
          eventStartDate: "2023-07-24",
          eventStartHour: "23:00",
          eventEndDate: "2023-07-25",
          eventEndHour: "01:00",
          registrationStartDate: "2023-07-25",
          registrationEndDate: "2023-07-25",
          closedToMembersChildEvent: true,
          brothersDiscountChildEvent: true,
        },
      },
    ],
  },
};



// WEBPACK FOOTER //
// ./src/app/admin/events-screen/tests/fixtures/parentEventMegaFormValues.ts